import { InjectionToken } from '@angular/core';

export const IDENTITY_URL = new InjectionToken<string>('IdentityURL');
export const DEBUG_FLAG = new InjectionToken<string>('DebugFlag');
export const POPUP_LOGIN = new InjectionToken<string>('PopupLogin');
export const APPNAME  = new InjectionToken<string>('AppName');
export const APPVERSION  = new InjectionToken<string>('AppVersion');
export const APPCOPYRIGHT  = new InjectionToken<string>('AppCopyright');
export const BASE_PATH = new InjectionToken<string>('basePath');
export const ALLOW_LAST_LOGIN = new InjectionToken<string>('AllowLastLogin');

// used by date input logic to handle 'Today+x' values
export const TODAY_YEAR = 3001;
export const ONE_DAY = 24 * 60 * 60 * 1000;  // hours*minutes*seconds*milliseconds
